"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegisterToUnmountSym = void 0;
exports.RegisterToUnmountSym = Symbol('RegisterToUnmount');
//# sourceMappingURL=symbolToFeature.js.map